<!--
 * @Description:
 * @version: V1.0.0
 * @Author: xiaoxiao
 * @Date: 2020-10-03 11:14:19
-->
<template>
  <div class="wrapper">
    <div class="advs">
      <a v-if="url" :href="url" target="_blank">
        <img :src="banner.atturl" alt="log">
      </a>
      <img v-else :src="banner.atturl" alt="log" @click="showTips('敬请期待！')">
    </div>
  </div>
</template>

<script>

export default {
  name: "block",
  props: [
    'data',
    'url',
  ],
  data() {
    return {
      banner: {
        atturl: ''
      },
    }
  },
  mounted() {
    this.banner.atturl = this.data.advList[0].atturl
  },
  methods: {
    showTips(string) {
      this.$Message.warning(string);
    }
  }
}
</script>

<style scoped lang="less">
.wrapper {
  width: 50%;
  margin: 5px 0;
  display: flex;
  flex-direction: row;
  a {
    display: block;
    width: 98%;
    img {
      width: 100%;
    }
  }
  .advs {
    width: 98%;
    img {
      width: 100%;
      min-height: 300px;
      cursor: pointer;
    }
  }
}
</style>



// WEBPACK FOOTER //
// block.vue?64c6ed9d